module.exports = __webpack_public_path__ + "static/media/23.6f08f38a.jpg";